<template>
  <svg
    width="1253"
    height="690"
    viewBox="0 0 1253 690"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g
      id="enifor-projects-map"
      opacity="0.8"
      filter="url(#filter0_d_5378_24279)"
    >
      <image :href="`${$baseUrl}images/mapviz.webp`" height="690" width="1253" />
      <g id="country-circles">
        <circle id="MX" cx="251.914" cy="328.078" r="8" fill="#A42456" />
        <circle id="GB" cx="583.66" cy="191.668" r="8" fill="#A42456" />
        <circle id="IT" cx="623.881" cy="251.889" r="8" fill="#A42456" />
        <circle id="ME" cx="654" cy="242" r="8" fill="#A42456" />
        <circle id="AL" cx="665" cy="255" r="8" fill="#A42456" />
        <circle id="DZ" cx="600.051" cy="303.488" r="8" fill="#A42456" />
        <circle id="LY" cx="648.029" cy="309.826" r="8" fill="#A42456" />
        <circle id="TN" cx="626" cy="280" r="8" fill="#A42456" />
        <circle id="EG" cx="693.439" cy="312.447" r="8" fill="#A42456" />
        <circle id="IQ" cx="739.176" cy="285.193" r="8" fill="#A42456" />
        <circle id="LB" cx="715" cy="284" r="8" fill="#A42456" />
        <circle id="CY" cx="700" cy="276" r="8" fill="#A42456" />
        <circle id="KZ" cx="814.008" cy="220.352" r="8" fill="#A42456" />
        <circle id="TM" cx="789.396" cy="258.373" r="8" fill="#A42456" />
        <circle id="OM" cx="787.344" cy="336.414" r="8" fill="#A42456" />
        <circle id="CI" cx="573.986" cy="383.826" r="8" fill="#A42456" />
        <circle id="GH" cx="591.902" cy="382.395" r="8" fill="#A42456" />
        <circle id="NG" cx="617.629" cy="377.92" r="8" fill="#A42456" />
        <circle id="GA" cx="630.113" cy="413.361" r="8" fill="#A42456" />
        <circle id="CD" cx="647.461" cy="416.836" r="8" fill="#A42456" />
        <circle id="AO" cx="650.271" cy="456.004" r="8" fill="#A42456" />
        <circle id="MZ" cx="713.924" cy="480.162" r="8" fill="#A42456" />
        <circle id="KE" cx="721.166" cy="409.119" r="8" fill="#A42456" />
        <circle id="PK" cx="821.838" cy="300.92" r="8" fill="#A42456" />
        <circle id="MM" cx="914.322" cy="331.846" r="8" fill="#A42456" />
        <circle id="VN" cx="957.627" cy="356.141" r="8" fill="#A42456" />
        <circle id="ID" cx="940.723" cy="422.373" r="8" fill="#A42456" />
        <circle id="TL" cx="1051.19" cy="422.615" r="8" fill="#A42456" />
        <circle id="AE" cx="780.48" cy="318.5" r="8" fill="#A42456" />
        <circle id="BH" cx="763" cy="312" r="8" fill="#A42456" />
      </g>
    </g>
    <defs>
      <filter
        id="filter0_d_5378_24279"
        x="0.75"
        y="0.75"
        width="1251.55"
        height="688.664"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation="10" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.580392 0 0 0 0 0.745098 0 0 0 0 0.788235 0 0 0 0.8 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_5378_24279"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_5378_24279"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
</template>

<script>
export default {
  computed: {
    circleSize() {
      return this.mobile || this.tablet ? "8" : "5";
    },
    mobile() {
      return this.$tvaMq === "mobile";
    },
    tablet() {
      return this.$tvaMq === "tablet";
    },
  },
};
</script>

<style lang="scss" scoped>
image {
  pointer-events: none;
}

.bg-countries {
  opacity: 0.8;
}

.country:not(.sdg-unselected):not(.unselected):hover {
  cursor: pointer;
}

circle {
  // pointer-events: none;
  transition: opacity 0.5s;

  &.unselected,
  &.sdg-unselected {
    opacity: 0.2;
  }

  &:not(.sdg-unselected):not(.unselected):hover {
    cursor: pointer;
  }
}

.st0 {
  fill: none;
}
.st1 {
  fill: none;
  stroke: #a51a3a;
  stroke-width: 0.75;
  stroke-linejoin: round;
}
.st2 {
  display: none;
}
.st3 {
  display: inline;
  fill: url(#SVGID_1_);
}
.st4 {
  display: inline;
  fill: url(#SVGID_00000132794681086533295930000003934505473079789203_);
}
.st5 {
  display: inline;
  fill: url(#SVGID_00000131342079514149972610000003686148607868985499_);
}
.st6 {
  opacity: 0.55;
  fill: #fffefa;
}
.st7 {
  fill: none;
  stroke: #fffefa;
  stroke-width: 0.3;
}
.st8 {
  opacity: 0.55;
}
.st9 {
  fill: #fffefa;
}
.st10 {
  fill: #fffefa;
  stroke: #fffefa;
  stroke-width: 0.3;
}
.st11 {
  opacity: 0.1;
  fill: none;
  stroke: #f5f5f5;
  enable-background: new;
}
.st12 {
  fill: url(#SVGID_00000139973609809049775480000012966113135209944251_);
}
.st13 {
  fill: url(#SVGID_00000160879437753706963210000017551374254959965837_);
}
.st14 {
  fill: url(#SVGID_00000173119719876634150480000009212957972400490166_);
}
.st15 {
  fill: url(#SVGID_00000150100820449491388520000015715049858631587978_);
}
.st16 {
  fill: url(#SVGID_00000155113149419676272760000014561372947658618009_);
}
.st17 {
  fill: url(#SVGID_00000031888241601329972650000000221616653482462594_);
}
.st18 {
  fill: url(#SVGID_00000182529862585921503380000015179010417258490247_);
}
.st19 {
  fill: url(#SVGID_00000085931477186089639700000017622440908706714021_);
}
.st20 {
  fill: url(#SVGID_00000073712115015496300670000017476590061330966178_);
}
.st21 {
  fill: url(#SVGID_00000085934140305378593330000005529540060710876828_);
}
.st22 {
  fill: url(#SVGID_00000044159300510033631240000012909147125487849098_);
}
.st23 {
  fill: url(#SVGID_00000102527484460506778130000001509456009761893533_);
}
.st24 {
  fill: url(#SVGID_00000009578083817597084960000014701799809830463405_);
}
.st25 {
  fill: url(#SVGID_00000142895157448656662790000017425790064778837690_);
}
.st26 {
  fill: url(#SVGID_00000090267961168284528130000007051284862963084222_);
}
.st27 {
  fill: url(#SVGID_00000170986444981039666490000007954466538007895200_);
}
.st28 {
  fill: #ffd300;
}
.st29 {
  fill: url(#SVGID_00000038397972750692239020000013227917696705127043_);
}
.st30 {
  fill: url(#SVGID_00000101782438442358903780000006548228045821072769_);
}
.st31 {
  fill: url(#SVGID_00000169537067854332752010000018393629942409571748_);
}
.st32 {
  fill: url(#SVGID_00000011027199742922435100000002074687641757715131_);
}
.st33 {
  fill: url(#SVGID_00000134948077477845303600000009768452652192760763_);
}
.st34 {
  fill: url(#SVGID_00000034091861937466824310000009539240868575307649_);
}
.st35 {
  fill: url(#SVGID_00000026854085229240748930000016529448952893387168_);
}
.st36 {
  fill: url(#SVGID_00000125593405500459547840000010772713938316278193_);
}
.st37 {
  fill: url(#SVGID_00000040535097483183715230000015916106754248896683_);
}
.st38 {
  fill: url(#SVGID_00000146461458459685244950000002518263632166204856_);
}
.st39 {
  fill: url(#SVGID_00000087381637449899858560000011945291307539901327_);
}
.st40 {
  fill: url(#SVGID_00000004517756694234133720000008786826868041846927_);
}
.st41 {
  fill: url(#SVGID_00000052820381266036204210000001762585511532347326_);
}
.st42 {
  fill: url(#SVGID_00000121978214084571742960000008454433858931417023_);
}
.st43 {
  fill: url(#SVGID_00000116947403454261062930000013239121068784192168_);
}
.st44 {
  fill: url(#SVGID_00000029738053513860462990000009646973677912068794_);
}
.st45 {
  fill: url(#SVGID_00000005268797330039296450000007541695689450809533_);
}
.st46 {
  fill: url(#SVGID_00000151534725318312696160000000118039243099266965_);
}
.st47 {
  fill: url(#SVGID_00000001657885722139839020000001104139788163509660_);
}
.st48 {
  fill: url(#SVGID_00000095337203017202667910000004185722165165595326_);
}
.st49 {
  fill: url(#SVGID_00000005256270219051479480000010335677446693676691_);
}
.st50 {
  fill: url(#SVGID_00000127029909329308674660000001421937076241235864_);
}
.st51 {
  fill: url(#SVGID_00000013887051747058570660000001913531020122575249_);
}
.st52 {
  fill: url(#SVGID_00000159432049169577824160000015352179159776875429_);
}
.st53 {
  fill: url(#SVGID_00000012465698276840256870000017056385747351847043_);
}
.st54 {
  fill: url(#SVGID_00000005247004079704664460000007285938146950033341_);
}
.st55 {
  fill: url(#SVGID_00000009548363807038247410000000370518928336933812_);
}
.st56 {
  fill: url(#SVGID_00000088832083392213755490000011924106435195113628_);
}
.st57 {
  fill: url(#SVGID_00000018215783804091631380000005494995724215042483_);
}
.st58 {
  fill: url(#SVGID_00000164506255413378246240000005064896161588063933_);
}
.st59 {
  fill: url(#SVGID_00000034809108404580259980000017463236445372188062_);
}
.st60 {
  fill: url(#SVGID_00000047770874767910133600000013411770919521426846_);
}
.st61 {
  fill: url(#SVGID_00000022527026552712962330000014323585289866625965_);
}
.st62 {
  fill: url(#SVGID_00000148628016406759740010000017086302118838639247_);
}
.st63 {
  fill: url(#SVGID_00000182517000311553493010000011076416338850879904_);
}
.st64 {
  fill: url(#SVGID_00000034057378341066520290000000261691642787431567_);
}
.st65 {
  fill: url(#SVGID_00000142891007695380696220000015045933946304932782_);
}
.st66 {
  fill: url(#SVGID_00000118398793610004206030000017278290933704750513_);
}
.st67 {
  fill: url(#SVGID_00000183955607644589464800000004733988355757383561_);
}
.st68 {
  fill: url(#SVGID_00000123402471060359924590000005344486199530786228_);
}
.st69 {
  fill: url(#SVGID_00000052065876551926260510000010081615854421595539_);
}
.st70 {
  fill: url(#SVGID_00000119094238550360543750000000950225505320521107_);
}
.st71 {
  fill: url(#SVGID_00000175293420212351478970000007576900936105633172_);
}
.st72 {
  fill: url(#SVGID_00000170987892838240569900000004655061185624827543_);
}
</style>
